import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';
import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';

import { ReactComponent as InfoIcon } from '/src/images/icons/info-icon.svg';
import { ReactComponent as SuccessIcon } from '/src/images/icons/success-icon.svg';

import { isBrowser } from '../../../helpers/is-browser';
import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';
import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import ImageWrapper from '../../image-wrapper/Image-wrapper';
import { RichText } from '../../rich-text/rich-text';
import Button from '../../ui/button/button';

interface DynamicOfferRedemptionProps {
  className?: string;
  offerRedemptionDetails?: {
    internalName: string;
    richText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
  };
  handleClose: () => void;
  tenantDetails: {
    offerName?: string;
    tenantName?: string;
    tenantLogo?: IContentfulImage;
  };
  node_locale: string;
}

export const DynamicOfferRedemption = ({
  className,
  offerRedemptionDetails,
  handleClose,
  tenantDetails,
  node_locale,
}: DynamicOfferRedemptionProps) => {
  const dictionary = useGetLibraryConstantsDictionary(node_locale);

  useEffect(() => {
    sendGtmEvent();
  }, []);

  const sendGtmEvent = () => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'offer_redemption',
        offer_name: tenantDetails?.offerName,
        offer_redeemed: 'yes',
        offer_redeemed_QR: 'yes',
      });
    }
  };

  return (
    <>
      <div className="text-headingm font-title gap-4 text-neutral-grey-700 text-center flex justify-center items-center flex-col">
        <SuccessIcon />
        {dictionary?.specialOfferClaimedOfferText}
      </div>
      <div className="text-center flex justify-center items-center text-bodyxl text-neutral-grey-700 flex-col">
        <div>{DateTime.now().toFormat('dd LLL, yyyy')}</div>
        <div>{DateTime.now().toFormat('HH:mm:ss')}</div>
      </div>
      <div className="bg-brand-blue-1/30 text-bodys font-sans text-brand-blue-3 rounded-md py-1 flex gap-2 pl-3 my-4">
        <InfoIcon /> <p>{dictionary?.dynamicOfferInfoText}</p>
      </div>
      {offerRedemptionDetails && (
        <div className="card w-[100%] overflow-y-scroll max-h-[23.5vh] flex flex-col align-centre items-center bg-background-primary rounded-md p-4 mt-2">
          <RichText
            richText={offerRedemptionDetails?.richText}
            assetClass={'w-[150px] h-[150px] mb-0'}
          />
        </div>
      )}
      <div className="flex mt-4">
        {tenantDetails?.tenantLogo && (
          <ImageWrapper
            gatsbyImageData={tenantDetails?.tenantLogo?.gatsbyImageData}
            file={tenantDetails?.tenantLogo?.file}
            svg={tenantDetails?.tenantLogo?.svg}
            alt={
              tenantDetails?.tenantLogo?.description
                ? tenantDetails?.tenantLogo.description
                : ''
            }
            className="h-12 w-12 lg:h-16 lg:w-16 rounded-md bg-brand-white"
            imgClassName="!object-contain"
          />
        )}
        <div className="ml-4 text-neutral-grey-700 font-sans">
          <div className="text-bodymheavy">{tenantDetails?.tenantName}</div>
          <div className="text-bodyl font-bold">{tenantDetails?.offerName}</div>
        </div>
      </div>
      <div className="button-container flex flex-col gap-4 mt-6">
        <Button variant="primary" onClick={handleClose}>
          {dictionary?.okayText}
        </Button>
      </div>
    </>
  );
};
